import { useState } from 'react';
import type { UseMutationResult } from '@tanstack/react-query';

import { ScheduleEditDialog } from './ScheduleEditDialog';

import { useToastStore } from '@/store';

interface ScheduleTarget {
  tableId: string;
  schedule: string | null;
}

export function useScheduleEditDialog(
  updateSchedule: UseMutationResult<unknown, Error, { tableId: string; schedule: string | null }>,
) {
  const [scheduleTarget, setScheduleTarget] = useState<ScheduleTarget | null>(null);
  const toast = useToastStore();

  const openScheduleDialog = (tableId: string, schedule: string | null) => {
    setScheduleTarget({ tableId, schedule });
  };

  const scheduleEditDialog = scheduleTarget ? (
    <ScheduleEditDialog
      open
      onOpenChange={(open) => { if (!open) setScheduleTarget(null); }}
      currentSchedule={scheduleTarget.schedule}
      onSave={async (schedule) => {
        try {
          await updateSchedule.mutateAsync({ tableId: scheduleTarget.tableId, schedule });
          toast.success('Schedule updated');
        } catch {
          toast.error('Failed to update schedule');
          return Promise.reject();
        }
      }}
    />
  ) : null;

  return { openScheduleDialog, scheduleEditDialog };
}
